import { cancellablePost, get, post } from "../../fetch-interceptor";
import { Dictionary } from "../../entities/common";
import { IAssignmentByDay, IPredecessorInfo, ITask } from "../../entities/Subentities";

export type FindTaskInfo = {
    id: string;
    name: string;
    startDate?: string;
    dueDate?: string;
    duration?: number;
    predecessor?: IPredecessorInfo[];
    parentIds: string[];
};

export const mapFindTaskInfoToLoadedTask = (task: FindTaskInfo): ITask => ({
    id: task.id,
    attributes: {
        Name: task.name,
        StartDate: task.startDate,
        DueDate: task.dueDate,
        Duration: task.duration,
        Predecessor: task.predecessor,
    },
    hierarchy: { parentIds: task.parentIds },
} as unknown as ITask);

export const findProjectTasks = (projectId: string, name?: string) =>
    cancellablePost<FindTaskInfo[]>(`/api/project/${projectId}/task/find`, { name }).promise;

export const fetchProjectTasksForPredecessors = (projectId: string) =>
    get<FindTaskInfo[]>(`/api/project/${projectId}/task/find`).then(tasks => tasks.map(mapFindTaskInfoToLoadedTask));

export const fetchExternalPredecessorTasks = (projectId: string, taskId: string) =>
    taskId
        ? post<ITask[]>(`/api/project/${projectId}/task/predecessor`, { taskId })
        : Promise.resolve([]);

export const fetchTaskAssignmentShares = (projectId: string, connectionId: string, taskId: string) =>
    get<IAssignmentByDay[]>(`api/project/${projectId}/assignmentByDay?connectionId=${connectionId}&taskIds=${taskId}`)
        .then(rows => rows.reduce((shares, row) => {
            const id = row.attributes.Resource?.id;
            if (id) {
                shares[id] = (shares[id] ?? 0) + (row.attributes.Effort ?? 0);
            }
            return shares;
        }, {} as Dictionary<number>));
